export enum PromptType {
  EVENT_SUGGESTED_DATA = 'EVENT_SUGGESTED_DATA',
  EVENT_FONT_AND_COLORS = 'EVENT_FONT_AND_COLORS',
  EVENT_DESCRIPTION = 'EVENT_DESCRIPTION',
  EVENT_CTA = 'EVENT_CTA',
  MOOD_BOARD_IMAGES = 'MOOD_BOARD_IMAGES',
  KEY_VISUAL1_IMAGE = 'KEY_VISUAL1_IMAGE',
  MOOD_BOARD_IMAGE = 'MOOD_BOARD_IMAGE',
  EVENT_SEO = 'EVENT_SEO',

  AGENDA_TITLE = 'AGENDA_TITLE',
  AGENDA_DESCRIPTION = 'AGENDA_DESCRIPTION',

  SPEAKER_DESCRIPTION = 'SPEAKER_DESCRIPTION',

  TICKET_NAME = 'TICKET_NAME',
  TICKET_DESCRIPTION = 'TICKET_DESCRIPTION',

  EVENT_TITLE = 'EVENT_TITLE',
  EVENT_SUBTITLE = 'EVENT_SUBTITLE',
  EVENT_IMAGE = 'EVENT_IMAGE',
}

export namespace PromptType {
  export function getAllPromptTypes(): PromptType[] {
    return [
      PromptType.EVENT_SUGGESTED_DATA,
      PromptType.EVENT_FONT_AND_COLORS,
      PromptType.EVENT_DESCRIPTION,
      PromptType.EVENT_CTA,
      PromptType.MOOD_BOARD_IMAGES,
      PromptType.KEY_VISUAL1_IMAGE,
      PromptType.MOOD_BOARD_IMAGE,
      PromptType.EVENT_SEO,

      PromptType.AGENDA_TITLE,
      PromptType.AGENDA_DESCRIPTION,

      PromptType.SPEAKER_DESCRIPTION,

      PromptType.TICKET_NAME,
      PromptType.TICKET_DESCRIPTION,

      PromptType.EVENT_TITLE,
      PromptType.EVENT_SUBTITLE,
      PromptType.EVENT_IMAGE,
    ];
  }
}
